import { render, staticRenderFns } from "./VoyageCargoCardNew.vue?vue&type=template&id=3130d37f&"
import script from "./VoyageCargoCardNew.vue?vue&type=script&lang=js&"
export * from "./VoyageCargoCardNew.vue?vue&type=script&lang=js&"
import style0 from "./VoyageCargoCardNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports